// String.prototype.localeCompare vs Intl.Collator.compare
// https://stackoverflow.com/a/52369951
var collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base"
});
export var sort = obj => {
  var next = {};
  Object.keys(obj).sort((a, b) => collator.compare(a, b)).forEach(key => {
    next[key] = obj[key];
  });
  return next;
};